import { useRef, useEffect } from 'react';

export function usePrevious(value) {
    // The ref object is a generic container whose current property is mutable ...
    // ... and can hold any value, similar to an instance property on a class
    const previousRef = useRef(null);

    // Store current value in ref
    useEffect(() => {
        previousRef.current = value;
    }, [value]); // Only re-run if value changes

    // Return previous value (happens before update in useEffect above)
    // TODO: use new implementation https://www.npmjs.com/package/@uidotdev/usehooks?activeTab=codeuseConstCallback.js
    // TODO(https://perpay.atlassian.net/browse/KEY-3811):
    // Ref values (the `current` property) may not be accessed during render. (https://react.dev/reference/react/useRef)
    // eslint-disable-next-line react-compiler/react-compiler
    return previousRef.current;
}
